import { Component, OnInit } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';

import { DirectionService } from '../../../../client/src/app/shared/services/direction.service';

@Component({
  selector: 'sh-dialog-modal',
  templateUrl: './dialog-modal.component.html',
  styleUrl: './dialog-modal.component.scss',
  standalone: false
})
export class DialogModalComponent implements OnInit {
  constructor(
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private directionService: DirectionService
  ) {}

  ngOnInit(): void {}

  public openDialog(): void {
    this.dialog.open(ExampleDialogComponent, {
      direction: this.directionService.direction$.value
    });
  }

  openSnackBar() {
    this.snackBar.openFromComponent(ExampleSnackBarComponent, {
      duration: 10 * 1000
    });
  }
}

@Component({
  selector: 'sh-example-dialog',
  templateUrl: 'dialog-content-example-dialog.html',
  standalone: false
})
export class ExampleDialogComponent {}

@Component({
  selector: 'sh-example-snack-ar',
  templateUrl: 'snack-bar-component-example-snack.html',
  standalone: false
})
export class ExampleSnackBarComponent {}
